export type PreservePredicate = (key: string) => boolean;

export function clearLocalStorageExcept(predicate: PreservePredicate): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) keys.push(key);
    }
    for (const key of keys) {
      if (!predicate(key)) {
        try {
          localStorage.removeItem(key);
        } catch {
          // noop
        }
      }
    }
  } catch {
    // noop
  }
}

export function clearLocalStoragePreservePrefixes(prefixes: string[]): void {
  clearLocalStorageExcept((key) => prefixes.some((p) => key.startsWith(p)));
}

export const DEFAULT_LOCK_PREFIX = 'diamond:lock:';

export function clearLocalStoragePreserveLocks(): void {
  clearLocalStoragePreservePrefixes([DEFAULT_LOCK_PREFIX]);
}
